import React from "react";

function ReportToolbar({
  onBack,
  onRun,
  onExportCsv,
  onExportPdf,
  onSave,
  canRun,
  canExportCsv,
  canExportPdf,
  running,
  exportingCsv,
  exportingPdf,
  savingReport
}) {
  return (
    <div className="sales-header-actions">
      <button
        type="button"
        className="sales-secondary-btn"
        onClick={onBack}
      >
        Back to Reports
      </button>

      <button
        type="button"
        className="sales-primary-btn"
        onClick={onRun}
        disabled={!canRun || running}
      >
        {running ? "Running..." : "Run Report"}
      </button>

      <button
        type="button"
        className="sales-secondary-btn"
        onClick={onExportCsv}
        disabled={!canExportCsv || exportingCsv}
      >
        {exportingCsv ? "Exporting..." : "Export CSV"}
      </button>

      <button
        type="button"
        className="sales-secondary-btn"
        onClick={onExportPdf}
        disabled={!canExportPdf || exportingPdf}
      >
        {exportingPdf ? "Exporting..." : "Export PDF"}
      </button>

      <button
        type="button"
        className="sales-secondary-btn"
        onClick={onSave}
        disabled={!canRun || savingReport}
      >
        {savingReport ? "Saving..." : "Save Report"}
      </button>
    </div>
  );
}

export default ReportToolbar;